var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoogleLetter = function SvgIconGoogleLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M17.64 9.204q-.002-.957-.164-1.84H9v3.485h4.844a4.15 4.15 0 0 1-1.809 2.708v2.266h2.921c1.702-1.57 2.684-3.878 2.684-6.619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M9 17.782c2.43 0 4.467-.802 5.956-2.177l-2.92-2.266c-.803.54-1.825.867-3.036.867-2.34 0-4.328-1.579-5.04-3.706H.965v2.324C2.446 15.76 5.482 17.782 9 17.782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M3.96 10.71A5.4 5.4 0 0 1 3.674 9c0-.597.106-1.17.286-1.71V4.966H.965A8.9 8.9 0 0 0 0 9c0 1.456.352 2.823.965 4.034l2.332-1.817z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M9 3.584c1.325 0 2.504.458 3.444 1.341l2.578-2.577C13.459.892 11.43 0 9 0 5.482 0 2.446 2.02.965 4.966L3.96 7.29C4.672 5.163 6.66 3.584 9 3.584"
  })));
};
export default SvgIconGoogleLetter;